export function getInjectorVideoElements(iframe: HTMLIFrameElement | null) {
  if (iframe && iframe.contentDocument) {
    const doc = iframe.contentDocument;
    const mainCandidates = doc.querySelectorAll('#__WIDGET_MAIN_VIDEO__');
    if (mainCandidates.length > 1) {
      console.warn(
        `[DEV] Found more than one (${mainCandidates.length}) widget element with main video id -- will use first element found`,
      );
    }
    const subCandidates = doc.querySelectorAll('#__WIDGET_SUB_VIDEO__');
    if (subCandidates.length > 1) {
      console.warn(
        `[DEV] Found more than one (${subCandidates.length}) widget element with sub video id -- will use first element found`,
      );
    }
    const main = mainCandidates.length ? (mainCandidates[0] as HTMLVideoElement) : null;
    const sub = subCandidates.length ? (subCandidates[0] as HTMLVideoElement) : null;
    const demo = doc.getElementById(
      '__WIDGET_DISPLAYDEMO_VIDEO__',
    ) as HTMLVideoElement | null;
    return { main, sub, demo };
  }
}

/**
 * Fixes various issues with the widget video being flipped for the admin viewing.
 * see: /widget/src/app/components/ChatWidget/AgentVideo/index.tsx
 */
export function fixFlippedWidgetVideo(
  isFlipped: boolean,
  isOutgoingVideoEnabled: boolean,
  mainVideo: HTMLElement | null,
  subVideo: HTMLElement | null,
) {
  if (!mainVideo) return;
  if (isFlipped) {
    mainVideo.classList.remove('mirror');
  } else {
    mainVideo.classList.add('mirror');
  }
  if (!subVideo) return;
  const TEMP_ICON_CLASS = '__TEMPORARY_ICON__';
  if (isFlipped) {
    mainVideo.style.opacity = '1';
    mainVideo.parentElement?.childNodes.forEach(n => {
      const el = n as HTMLElement | SVGElement;
      if (
        el.className &&
        typeof el.className === 'string' &&
        el.className.includes('AgentVideo__icons--')
      ) {
        el.style.opacity = '0';
        const icon = el.querySelector('svg')?.cloneNode(true) as HTMLElement;
        if (icon && !subVideo.parentElement?.querySelector(`.${TEMP_ICON_CLASS}`)) {
          icon.style.position = 'absolute';
          icon.style.zIndex = '1';
          icon.style.fill = '#FFFFFF99';
          icon.style.left = '50%';
          icon.style.top = '50%';
          icon.style.transform = 'translate(-50%, -50%)';
          icon.setAttribute('class', TEMP_ICON_CLASS);
          subVideo.parentElement?.prepend(icon);
        }
      }
      // Always try to remove if cam enabled
      if (isOutgoingVideoEnabled) {
        subVideo?.parentElement?.querySelector(`.${TEMP_ICON_CLASS}`)?.remove();
      }
    });
    if (isOutgoingVideoEnabled) {
      subVideo.style.opacity = '1';
      mainVideo.parentElement?.classList.remove('visible');
    } else {
      mainVideo.parentElement?.classList.add('visible');
      subVideo.style.opacity = '0';
    }
  } else {
    mainVideo.style.opacity = '';
    mainVideo.parentElement?.childNodes.forEach(n => {
      const el = n as HTMLElement | SVGElement;
      if (
        el.className &&
        typeof el.className === 'string' &&
        el.className.includes('AgentVideo__icons--')
      ) {
        el.style.opacity = '';
      }
    });
    subVideo?.parentElement?.querySelector(`.${TEMP_ICON_CLASS}`)?.remove();
  }
}

/**
 * Fixes various issues with the widget maximized videos being flipped for the agent viewing.
 * see: widget/src/app/components/MaximizedContent/index.tsx
 */
export function fixFlippedMaximizedContentW20(
  isFlipped: boolean,
  mainVideo: HTMLVideoElement | null,
  subVideo: HTMLVideoElement | null,
) {
  const mic = selectSubVideoMicW20(subVideo);
  const mainVideoBackdrop = selectMainVideoBackdropW20(mainVideo);
  const mainVideoAvatarWrapper = selectMainVideoAvatarWrapperW20(mainVideo);
  if (isFlipped) {
    // Flipped
    // If max mode, hide the mic indicator in the sub video since it represents
    // the visitor mic, not our own
    if (mic) {
      mic.style.opacity = '0';
    }
    if (mainVideoBackdrop) {
      if (mainVideo?.srcObject) {
        mainVideoBackdrop.style.opacity = '1';
        if (mainVideoAvatarWrapper) {
          mainVideoAvatarWrapper.style.opacity = '0';
        }
      } else {
        mainVideoBackdrop.style.opacity = '';
        if (mainVideoAvatarWrapper) {
          mainVideoAvatarWrapper.style.opacity = '';
        }
      }
    }
  } else {
    // Not flipped
    if (mic) {
      mic.style.opacity = '';
    }
    if (mainVideoBackdrop) {
      mainVideoBackdrop.style.opacity = '';
      if (mainVideoAvatarWrapper) {
        mainVideoAvatarWrapper.style.opacity = '';
      }
    }
  }
}

const selectSubVideoMicW20 = (subVideo: HTMLElement | null) => {
  const el = subVideo?.parentElement?.querySelector('[class^=MaximizedContent__mic--]');
  if (el) {
    return el as HTMLElement;
  }
  return null;
};

const selectMainVideoBackdropW20 = (mainVideo: HTMLElement | null) => {
  const el = mainVideo?.parentElement?.parentElement?.querySelector(
    '[class^=MaximizedContent__MainVideoBackdrop--]',
  );
  if (el) {
    return el as HTMLElement;
  }
  return null;
};

const selectMainVideoAvatarWrapperW20 = (mainVideo: HTMLElement | null) => {
  const el = mainVideo?.parentElement?.parentElement?.querySelector(
    '[class^=MaximizedContent__AgentAvatarWrapper--]',
  );
  if (el) {
    return el as HTMLElement;
  }
  return null;
};
